// Tipos y subtipos de movimiento/categoría. Opción a): deudas, inversiones y
// transferencias NO afectan al Resultado (ingresos − gastos).
export const TX_TYPES = ["income", "expense", "debt", "investment", "transfer", "savings"];
export const CAT_KINDS = ["income", "expense", "debt", "investment", "transfer", "savings"];
export const TX_SCOPES = ["professional", "personal", "shared", "unassigned"];
export const DEBT_SUBTYPES = ["debt_received", "debt_repayment", "loan", "training_loan", "loan_installment", "other"];
export const INVESTMENT_SUBTYPES = ["stocks", "etf", "crypto", "life_insurance", "pension", "plan", "other"];
export const subtypesFor = (kind) =>
  kind === "debt" ? DEBT_SUBTYPES : kind === "investment" ? INVESTMENT_SUBTYPES : [];
